<template>
  <el-dialog title="退款记录" :visible.sync="refundForm.refundDetailsDialog" :append-to-body="true" class="useDetails" width="1300px">
    <el-collapse v-model="activeNames" accordion class="useDetails-collapse" @change="handleChange">
      <div v-for="(value, key) in refundDetailsList" :key="key" class="useDetails">
        <el-collapse-item :name="key">
          <template slot="title">
            <div class="useDetails-top">
              <div class="h1">退款时间：{{ value.createTime||'--' }}</div>
              <div class="h1">退款金额：{{ '￥'+value.amount||'--' }}</div>
              <!-- 退款类型（0:没有退款类型，1：现金支付,3:会员卡支付,5:赊账,9:微信支付（官方）,10:支付宝（官方），11:微信（通联），12:支付宝（通联）,13:翼支付微信，14：翼支付支付宝,,15:合利宝微信，16：合利宝支付宝,20:部分支付剩余款项扣除，21：赊账还款扣除） -->
              <div v-if="value.refundPayItemList.length>0" class="h1">
                退款方式：
                <span v-for="(item,index) in value.refundPayItemList" :key="index">
                  {{ item.payTypeName }}{{ item.amount?'(￥'+item.amount+')':'--' }}
                </span>
                <!-- <el-popover placement="right-start" width="200" trigger="hover" popper-class="filterBar">
                  <span v-for="(item,index) in value.refundPayItemList" :key="index">
                    {{ item.payTypeName }}{{ item.amount?'(￥'+item.amount+')':'--' }}
                  </span>
                  <span slot="reference">
                    <span v-for="(item,index) in value.refundPayItemList" :key="index">
                      {{ item.payTypeName }}{{ item.amount?'(￥'+item.amount+')':'--' }}
                    </span>
                  </span>
                </el-popover> -->
              </div>
              <div v-else class="h1">退款方式：--</div>
            </div>
          </template>
          <el-table :data="value.refundItemList" tooltip-effect="light" class="useDetails-table" width="100%">
            <el-table-column label="项目/产品/套餐" :show-overflow-tooltip="true" prop="refundName">
              <template slot-scope="scope">
                {{ scope.row.refundName||'--' }}
              </template>
            </el-table-column>
            <el-table-column label="退款类型" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <!-- 退款类型（0:退款,1:退次数,2:退货,3:退款退货,4:退次数退货） -->
                {{ scope.row.refundType==0?'退金额':scope.row.refundType==1?'退次数':scope.row.refundType==2?'退货':scope.row.refundType==3?'退款退货':scope.row.refundType==4?'退次数退货' :'--' }}
              </template>
            </el-table-column>
            <el-table-column label="退款信息" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <!--退金额0- 退款金额￥10.00 -->
                <!--退次数1- 已返还套餐划扣（1次） -->
                <!--退货2- 已退货 -->
                <!--退款退货3- 已退货，退款金额￥10.00 -->
                <!--退次数退货4- 已退货，已返还套餐划扣（2次） -->
                <span v-if="scope.row.refundType==0">退款金额{{ '￥'+scope.row.amount||'--' }}</span>
                <span v-if="scope.row.refundType==1">{{ '已返还套餐划扣（' + scope.row.count + '次）'||'--' }}</span>
                <span v-if="scope.row.refundType==2">已退货</span>
                <span v-if="scope.row.refundType==3">{{ '已退货，退款金额￥' +scope.row.amount||'--' }}</span>
                <span v-if="scope.row.refundType==4">{{ '已退货，已返还套餐划扣（' +scope.row.count+ '次）'||'--' }}</span>
              </template>
            </el-table-column>
          </el-table>
          <p class="useDetails-p">
            <span>退款发起人：{{ value.initiatorName || '--' }}</span>
            <span>退款授权人：{{ value.dutyName || '--' }}</span>
          </p>
          <p class="useDetails-p">退款原因：{{ value.remark||'--' }}</p>
        </el-collapse-item>
      </div>
    </el-collapse>
  </el-dialog>
</template>
<script>
import { getRefundPayList } from '../api';

export default {
  data() {
    return {
      refundDetailsList: [],
      refundForm: {
        refundDetailsDialog: false,
        id: ''
      },
      activeNames: [0]
    };
  },
  // 监听会员ID的变化
  watch: {
    'refundForm.refundDetailsDialog': function (val) {
      if (val) this.detailsData();
    }
  },
  mounted() {
    const vm = this;
    vm.$emit('refundRecord', vm.refundForm);
  },
  methods: {
    handleChange(val) {
      this.activeNames = val;
    },
    // 付款记录详情
    detailsData() {
      const data = {
        orderId: this.refundForm.id
      };
      getRefundPayList(data).then((res) => {
        this.refundDetailsList = res.data;
        console.log('ya1', this.refundDetailsList);
      });
    },
  }
};
</script>
<style lang="less" scoped>
.useDetails{
  max-height: 80%;
  top: 10%;
  padding-bottom:20px;
}
.useDetails-top{
  width: 100%;
  .h1{
    width: calc(100% / 3);
    // display: inline-block;
    display: inline-flex;
    font-size: 14px;
    color: #2D2F33;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
  }
  span{
    font-size: 14px;
    color: #2D2F33;
    line-height: 44px;
    // width: 300px;
  }
  span:nth-child(2){
    // padding: 0 80px;
  }
}
.useDetails-table{
  margin: 20px auto;
  width: 100%;
}
.useDetails-collapse {
  border: none!important;
  overflow: auto;
  width: 1240px;
}

.useDetails-p{
font-size: 14px;
color: #606266;
padding-top:20px;
display: flex;
text-align: left;
 span{
   flex: 1;
 }
}
</style>
